class WindowDimensions {

    static getMaxMobilWidth() {

        return 360;     //  Based on src/css/style.css

    }

    static getWindowDimensions(key = '') {

        let windowHeight = window.innerHeight;
        let windowWidth = window.innerWidth;

        let topNavHeight = (windowWidth > this.getMaxMobilWidth()) ? 72 : 56;       //  Based on src/css/style.css
        let leftNavWidth = (windowWidth > this.getMaxMobilWidth()) ? 110 : 50;      //  Based on src/css/style.css

        let newDimensions = {
            windowHeight: windowHeight,
            windowWidth: windowWidth,
            logoBoxHeight: topNavHeight,
            logoBoxWidth: leftNavWidth,
            scrollBoxHeight: windowHeight - topNavHeight,
            scrollBoxWidth: leftNavWidth,
            topBarHeight: topNavHeight,
            topBarWidth: windowWidth - leftNavWidth,
            contentAreaHeight: windowHeight - topNavHeight,
            contentAreaWidth: windowWidth - leftNavWidth,
        };

        if (newDimensions[key]) {
            return newDimensions[key];
        } else {
            return newDimensions;
        }

    }

}

export default WindowDimensions;